
import { defineComponent, PropType, reactive } from 'vue'
import Memo from '../types/Memo'
import MemoItem from './MemoItem.vue'
import AddButton from './AddButton.vue'
import DeleteButton from './DeleteButton.vue'

interface State {
  memos: Memo[] | undefined;
}

export default defineComponent({
  name: 'MemoList',
  components: {
    MemoItem,
    AddButton,
    DeleteButton
  },
  props: {
    memos: {
      type: Object as PropType<Memo[]>
    }
  },
  emits: ['editMemo', 'add', 'delete'],
  setup(props, context) {
    const state = reactive<State>({
      memos: props.memos
    })
    const onClickMemo = (id: number) => {
      context.emit('editMemo', id)
    }
    const addMemo = () => {
      context.emit('add')
    }

    const deleteAll = () => {
      context.emit('delete')
    }

    return {
      state,
      onClickMemo,
      addMemo,
      deleteAll
    }
  },
})
